import styled, {ComponentSelector} from '@emotion/styled';
import {mixinFocus} from 'webapp-lib/styling';

import {StyledListItem} from '#/List/Item/styles';
import {
  Dropdown,
  HeaderLabel,
  StyledSelectBox,
} from '#/form/selectable-input/SelectBox/styles';

import {IconPlacement, Props} from '.';

const color = ({flat, bordered, disabled}: Props): string => {
  if (flat && bordered) {
    return disabled
      ? 'var(--color-buttons-primary-inactive)'
      : 'var(--color-buttons-primary-active)';
  }

  if (flat) {
    return disabled
      ? 'var(--color-core-grey)'
      : 'var(--color-buttons-primary-active)';
  }

  return 'var(--color-core-white)';
};

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const Content = styled.div<Props>`
  display: flex;
  align-items: center;
  flex-direction: ${({iconPlacement}): string =>
    iconPlacement === IconPlacement.Left ? 'row' : 'row-reverse'};

  svg {
    ${({iconRotation}): string =>
      iconRotation ? `transform: rotate(${iconRotation}deg);` : ''}
    width: 16px;
    height: 16px;
  }
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const StyledButton = styled.button`
  text-transform: uppercase;
  position: relative;
  user-select: none;
  cursor: ${({disabled}): string => (disabled ? 'not-allowed' : 'pointer')};
  height: ${({bordered, children, flat}): string =>
    bordered || children || !flat ? '32px' : 'unset'};
  border: ${({bordered}): string =>
      bordered ? 'var(--regular-border-width)' : '0px'}
    solid
    ${({disabled}): string =>
      disabled
        ? 'var(--color-buttons-primary-inactive)'
        : 'var(--color-buttons-primary-active)'};
  border-radius: var(--button-border-radius);
  padding: ${({bordered, Icon, children, flat}): string =>
    bordered || children || !flat
      ? 'var(--gutter-tiny) var(--gutter)'
      : Icon
        ? 'var(--gutter-tiny)'
        : '0'};
  background-color: ${({flat, disabled, danger}): string =>
    flat
      ? 'transparent'
      : disabled && danger
        ? 'var(--color-buttons-delete-inactive)'
        : disabled && !danger
          ? 'var(--color-buttons-primary-inactive)'
          : danger
            ? 'var(--color-buttons-delete-active)'
            : 'var(--color-buttons-primary-active)'};
  color: ${color};
  font-weight: var(--button-font-weight);
  font-size: var(--font-size-default);
  text-align: center;
  display: flex;
  flex-direction: ${({iconPlacement}): string =>
    iconPlacement === IconPlacement.Left ? 'row-reverse' : 'row'};
  justify-content: center;
  align-items: center;

  :hover {
    ${({flat, disabled, danger}): string =>
      disabled || flat
        ? ''
        : danger
          ? `background-color: var(--color-buttons-delete-hover);`
          : `background-color: var(--color-buttons-primary-hover);`}
    ${({bordered, flat, disabled}): string =>
      disabled || (!flat && !bordered)
        ? ''
        : `color: ${
            bordered
              ? 'var(--color-buttons-primary-hover)'
              : 'var(--color-core-dark-grey)'
          };`}
    border: ${({bordered}): string =>
      bordered ? 'var(--regular-border-width)' : '0px'} solid
       ${({disabled, bordered}): string =>
      disabled
        ? 'var(--color-buttons-primary-inactive)'
        : bordered
          ? 'var(--color-buttons-primary-hover)'
          : 'var(--color-buttons-primary-active)'};
  }

  box-sizing: content-box;

  :focus {
    ${mixinFocus}
  }

  ${StyledSelectBox as ComponentSelector} {
    display: block;

    ${HeaderLabel as ComponentSelector} {
      svg {
        fill: ${color};
      }
    }

    ${Dropdown as ComponentSelector} {
      margin-top: 1px;
      text-align: left;

      ${StyledListItem as ComponentSelector} {
        color: ${color};
        font-weight: var(--font-weight-paragraph-title);
        font-size: var(--font-size-default);
        cursor: pointer;
        background-color: var(--color-buttons-primary-active);

        :hover {
          background-color: var(--color-buttons-primary-hover);
        }
      }
    }
  }

  svg {
    fill: ${color};
  }

  ${Content as ComponentSelector} {
    svg {
      ${({children, iconPlacement, Icon}): string =>
        children && Icon
          ? iconPlacement === IconPlacement.Left
            ? 'margin-right: var(--gutter-little);'
            : iconPlacement === IconPlacement.Right
              ? 'margin-left: var(--gutter-little);'
              : ''
          : ''}
    }
  }
`;
